<template>
    <div>
        <!-- LOADING -->
        <div v-if="loading" class="loading-overlay">
            <div class="loading-content">
                <div class="spinner-border text-primary"></div>
                <div class="mt-3">Mohon tunggu...</div>
            </div>
        </div>

        <div class="p-3">
            <div class="d-flex justify-content-between mb-3">
                <h3>Update Kategori & Cara Bayar</h3>

                <button class="btn btn-secondary" @click="openHistory">
                    <i class="fa fa-history"></i> History
                </button>
            </div>

            <hr />

            <!-- SEARCH -->
            <div class="card mb-3">
                <div class="card-header bg-primary text-white">
                    Pencarian Pasien
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Medrec / Nama</label>
                            <input
                                v-model="filter.search"
                                class="form-control"
                                @keyup.enter="getAllPasien"
                            />
                        </div>

                        <div class="col-md-2 d-flex align-items-end">
                            <button
                                class="btn btn-primary"
                                @click="getAllPasien"
                            >
                                Cari
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TABLE -->
            <div class="card">
                <div class="card-header bg-primary text-white">Data Pasien</div>

                <div class="card-body">
                    <div id="table-data"></div>
                </div>
            </div>

            <!-- MODAL DETAIL -->
            <div class="modal fade" id="modal-detail">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5>Detail Regno</h5>
                            <button
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <input
                                class="form-control mb-3"
                                placeholder="Cari Regno"
                                v-model="detail_search"
                                @input="filterRegno"
                            />

                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Regno</th>
                                        <th>Tanggal</th>
                                        <th>Kategori</th>
                                        <th>Cara Bayar</th>
                                        <th>Total</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        v-for="item in detail_filtered"
                                        :key="item.Regno"
                                    >
                                        <td>{{ item.Regno }}</td>
                                        <td>{{ item.Regdate }}</td>
                                        <td>{{ item.kategori_total }}</td>
                                        <td>{{ item.carabayar_total }}</td>
                                        <td>{{ item.total }}</td>
                                        <td>
                                            <button
                                                class="btn btn-warning btn-sm"
                                                @click="openUpdate(item)"
                                            >
                                                Update
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL UPDATE -->
            <div class="modal fade" id="modal-update">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5>Update Kategori & Cara Bayar</h5>
                            <button
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <div class="mb-2">
                                <label>Regno</label>
                                <input
                                    class="form-control"
                                    v-model="form.regno"
                                    readonly
                                />
                            </div>

                            <div class="mb-2">
                                <label>Kategori Lama</label>
                                <input
                                    class="form-control"
                                    v-model="form.kategori_lama"
                                    readonly
                                />
                            </div>

                            <div class="mb-2">
                                <label>Cara Bayar Lama</label>
                                <input
                                    class="form-control"
                                    v-model="form.kdcbayar_lama"
                                    readonly
                                />
                            </div>

                            <hr />

                            <div class="mb-2">
                                <label>Kategori Baru</label>
                                <select
                                    class="form-control"
                                    v-model="form.kategori"
                                    @change="getCaraBayar"
                                >
                                    <option
                                        v-for="k in kategori_list"
                                        :key="k.KdKategori"
                                        :value="k.KdKategori"
                                    >
                                        {{ k.NmKategori }}
                                    </option>
                                </select>
                            </div>

                            <div class="mb-2">
                                <label>Cara Bayar Baru</label>
                                <select
                                    class="form-control"
                                    v-model="form.kdcbayar"
                                >
                                    <option
                                        v-for="c in carabayar_list"
                                        :key="c.KdCbayar"
                                        :value="c.KdCbayar"
                                    >
                                        {{ c.NMCbayar }}
                                    </option>
                                </select>
                            </div>

                            <hr />

                            <table class="table table-bordered">
                                <tr v-for="i in preview" :key="i.table">
                                    <td>{{ i.table }}</td>
                                    <td>{{ i.count }}</td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <th>{{ grand_total }}</th>
                                </tr>
                            </table>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" @click="saveUpdate">
                                Simpan
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- HISTORY -->
            <div class="modal fade" id="modal-history">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5>History Update</h5>
                            <button
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Tanggal</th>
                                        <th>Medrec</th>
                                        <th>Regno</th>
                                        <th>Kategori Lama</th>
                                        <th>Kategori Baru</th>
                                        <th>Cara Bayar Lama</th>
                                        <th>Cara Bayar Baru</th>
                                        <th>User</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="h in history" :key="h.id">
                                        <td>{{ h.tanggal_update }}</td>
                                        <td>{{ h.medrec }}</td>
                                        <td>{{ h.regno }}</td>
                                        <td>{{ h.kategori_lama }}</td>
                                        <td>{{ h.kategori_baru }}</td>
                                        <td>{{ h.kdcbayar_lama }}</td>
                                        <td>{{ h.kdcbayar_baru }}</td>
                                        <td>{{ h.nama }}</td>
                                        <td>
                                            <span
                                                v-if="h.rollback_at"
                                                class="badge bg-success"
                                                >Rollback</span
                                            >
                                            <span
                                                v-else
                                                class="badge bg-warning"
                                                >Active</span
                                            >
                                        </td>
                                        <td>
                                            <button
                                                v-if="!h.rollback_at"
                                                class="btn btn-danger btn-sm"
                                                @click="rollback(h)"
                                            >
                                                Rollback
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
    data() {
        return {
            loading: false,

            table: null,

            selectedMedrec: null,

            filter: {
                search: "",
            },

            detail: [],
            detail_filtered: [],
            detail_search: "",

            kategori_list: [],
            carabayar_list: [],

            preview: [],
            grand_total: 0,

            history: [],

            form: {
                regno: "",
                kategori_lama: "",
                kdcbayar_lama: "",
                kategori: "",
                kdcbayar: "",
            },
        };
    },

    mounted() {
        this.getAllPasien();
    },

    watch: {
        loading(val) {
            if (val) {
                document.body.classList.add("loading-active");
            } else {
                document.body.classList.remove("loading-active");
            }
        },
    },

    methods: {
        async getAllPasien() {
            this.loading = true;

            const url = `/api/update-kategori-carabayar/get-all-pasien?search=${this.filter.search}`;

            if (this.table) {
                this.table.destroy();
            }

            this.table = new Tabulator("#table-data", {
                layout: "fitColumns",
                pagination: true,
                paginationMode: "remote",
                ajaxURL: url,

                ajaxResponse: (url, params, response) => {
                    this.loading = false;
                    return response?.data || { data: [], last_page: 1 };
                },

                columns: [
                    { title: "Medrec", field: "Medrec" },
                    { title: "Nama", field: "Firstname" },
                    { title: "Total", field: "total_regno" },

                    {
                        title: "Action",
                        formatter: () =>
                            `<button class='btn btn-primary btn-sm'>Detail</button>`,
                        cellClick: (e, cell) => {
                            this.openDetail(cell.getRow().getData());
                        },
                    },
                ],
            });
        },

        async openDetail(row) {
            this.loading = true;

            this.selectedMedrec = row.Medrec;

            try {
                const res = await axios.get(
                    "/api/update-kategori-carabayar/get-detail-regno",
                    {
                        params: {
                            medrec: row.Medrec,
                        },
                    }
                );

                this.detail = res.data.data;
                this.detail_filtered = [...res.data.data];

                const modalEl = document.getElementById("modal-detail");

                const instance =
                    bootstrap.Modal.getInstance(modalEl) ||
                    new bootstrap.Modal(modalEl);

                instance.show();
            } finally {
                this.loading = false;
            }
        },

        filterRegno() {
            const k = this.detail_search.toLowerCase();
            this.detail_filtered = this.detail.filter((i) =>
                i.Regno.toLowerCase().includes(k)
            );
        },

        async openUpdate(item) {
            this.loading = true;

            this.form = {
                regno: item.Regno,

                kategori_lama: item.NmKategori,
                kdcbayar_lama: item.NMCbayar,

                kategori: "",
                kdcbayar: "",
            };

            const preview = await axios.get(
                "/api/update-kategori-carabayar/get-preview-update",
                {
                    params: {
                        regno: item.Regno,
                    },
                }
            );

            this.preview = preview.data.data.tables;
            this.grand_total = preview.data.data.total;

            this.form.kategori = preview.data.data.kategori_kode;

            const kategori = await axios.get(
                "/api/update-kategori-carabayar/get-master"
            );

            this.kategori_list = kategori.data.data;

            const cb = await axios.get(
                "/api/update-kategori-carabayar/get-carabayar",
                {
                    params: {
                        kategori: this.form.kategori,
                    },
                }
            );

            this.carabayar_list = cb.data.data;

            this.$nextTick(() => {
                this.form.kdcbayar = preview.data.data.kdcbayar_kode;
            });

            new bootstrap.Modal(document.getElementById("modal-update")).show();

            this.loading = false;
        },

        async getCaraBayar() {
            if (!this.form.kategori) return;

            const res = await axios.get(
                "/api/update-kategori-carabayar/get-carabayar",
                {
                    params: {
                        kategori: this.form.kategori,
                    },
                }
            );

            this.carabayar_list = res.data.data;

            this.form.kdcbayar = "";
        },

        async saveUpdate() {
            const confirm = await Swal.fire({
                title: "Update data?",
                icon: "warning",
                showCancelButton: true,
            });

            if (!confirm.isConfirmed) return;

            this.loading = true;

            try {
                const payload = {
                    regno: this.form.regno,
                    kategori: this.form.kategori,
                    kdcbayar: this.form.kdcbayar,
                };

                await axios.post(
                    "/api/update-kategori-carabayar/update",
                    payload
                );

                const res = await axios.get(
                    "/api/update-kategori-carabayar/get-detail-regno",
                    {
                        params: {
                            medrec: this.selectedMedrec,
                        },
                    }
                );

                this.detail = res.data.data;
                this.detail_filtered = [...res.data.data];

                this.loading = false;

                bootstrap.Modal.getInstance(
                    document.getElementById("modal-update")
                ).hide();

                await Swal.fire("Success", "Update berhasil", "success");

                this.table.replaceData(
                    `/api/update-kategori-carabayar/get-all-pasien?search=${this.filter.search}`
                );
            } catch (e) {
                this.loading = false;

                console.error(e);

                Swal.fire(
                    "Error",
                    e.response?.data?.message || "Terjadi kesalahan",
                    "error"
                );
            }
        },

        async openHistory() {
            this.loading = true;

            const res = await axios.get(
                "/api/update-kategori-carabayar/history"
            );

            this.history = res.data.data.data;

            new bootstrap.Modal(
                document.getElementById("modal-history")
            ).show();

            this.loading = false;
        },

        async rollback(item) {
            const c = await Swal.fire({
                title: "Rollback?",
                icon: "warning",
                showCancelButton: true,
            });

            if (!c.isConfirmed) return;

            this.loading = true;

            try {
                await axios.post("/api/update-kategori-carabayar/rollback", {
                    log_id: item.id,
                });

                const modalEl = document.getElementById("modal-history");
                const modal = bootstrap.Modal.getInstance(modalEl);

                if (modal) {
                    modal.hide();
                }

                document
                    .querySelectorAll(".modal-backdrop")
                    .forEach((e) => e.remove());

                document.body.classList.remove("modal-open");
                document.body.style.removeProperty("padding-right");

                this.loading = false;

                await Swal.fire("Success", "Rollback berhasil", "success");

                this.openHistory();
            } catch (e) {
                this.loading = false;

                Swal.fire(
                    "Error",
                    e.response?.data?.message ?? "Rollback gagal",
                    "error"
                );
            }
        },
    },
};
</script>
<style scoped>
.loading-overlay {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;

    background: rgba(0, 0, 0, 0.45);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 999999;

    pointer-events: all;
}

.loading-content {
    background: #fff;
    padding: 20px 25px;
    border-radius: 10px;
    text-align: center;
    min-width: 200px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.25);
}

body.loading-active {
    overflow: hidden !important;
    pointer-events: none;
}

body.loading-active .loading-overlay {
    pointer-events: all;
}
</style>
